/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class AttendanceMessages extends Component {
  @service
  notifications;

  @service
  toaster;

  @tracked groupStyling = false;
  timetableDay = null;
  date = '';

  get buttonClasses() {
    if (this.groupStyling) {
      return 'adjoining-last attendance-group-messages';
    }

    return '';
  }

  copyNoteToAllPeriods() {}
  copyNoteToFirstPeriod() {}

  // Extracts the caregiver specified reason for absence from the message
  // Message is in the format: {LearnerName} Is {AbsenceType} today because: {reason}
  @computed('messages.[]')
  get reason() {
    if (isEmpty(this.messages)) {
      return '';
    }
    // If no reason specified there won't be any ':' so we can safely return ''
    let messageComponents = this.messages[0].content.split(': ');
    if (messageComponents <= 1) {
      return '';
    }
    // Take the components, slice off the first string, then join the remainder.
    // Therefore, any ':' in the caregiver reason will be preserved.
    return (
      messageComponents.slice(1).join(':') +
      ` (Reported by: ${this.messages[0].author.get('fullName')})`
    );
  }

  splitReasonFromMessage(message) {
    let content = message.content.split(': ');
    if (isEmpty(content)) {
      return '';
    }

    let reason = content.slice(1).join(':');
    if (reason.length > 0) {
      reason = reason.charAt(0).toUpperCase() + reason.slice(1);
    }
    return (
      reason + ` (Reported by: ${this.messages[0].author.get('fullName')})`
    );
  }

  // Mark notifications for this message as read
  @action
  markAsRead() {
    if (!isEmpty(this.messages)) {
      // Mark these messages as read, if the user was notified.
      let entityIds = mapBy(this.messages, 'id');
      this.notifications.markRead(entityIds);
    }
  }

  @action
  toggleDialog() {
    this.toggleProperty('attendanceMessagesDialogOpen');
    if (this.attendanceMessagesDialogOpen && !isEmpty(this.messages)) {
      // Mark these messages as read, if the user was notified.
      let entityIds = mapBy(this.messages, 'id');
      this.notifications.markRead(entityIds);
    }
  }

  @action
  copyToClipboard(message) {
    let content = `${message.content} (reported by ${message.get(
      'author.fullName',
    )})`;
    navigator.clipboard.writeText(content).then(() => {
      this.toaster.success('Attendance Note copied to clipboard');
    });
    this.toggleDialog();
  }

  @action
  handleCopyNoteToAllPeriods(message, dayString) {
    let noteContent = this.splitReasonFromMessage(message);
    this.copyNoteToAllPeriods(noteContent, dayString, this.timetableDay);
    this.toggleDialog();
  }

  @action
  handleCopyNoteToFirstPeriod(message, dayString) {
    let noteContent = this.splitReasonFromMessage(message);
    this.copyNoteToFirstPeriod(noteContent, dayString, this.timetableDay);
    this.toggleDialog();
  }
}
